uniform float uTime;
uniform vec3 pickerPosition;
varying vec3 vPosition;

void main() {
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);

    modelPosition.x = clamp(modelPosition.x, -75.0, 75.0);
    modelPosition.y = clamp(modelPosition.y, -75.0, 75.0);
    modelPosition.z = clamp(modelPosition.z, -75.0, 75.0);

    vec4 viewPosition = viewMatrix * modelPosition;
    gl_Position = projectionMatrix * viewPosition;

    // --- RING ANIMATION LOGIC ---

    float speed = 1.5;

    // Animated ring radius that pulses in and out
    float ringRadius = 40.0 + sin(uTime * speed * 0.5) * 30.0;

    // Ring thickness - how narrow the band of large particles is
    float ringWidth = 10.0;

    float dist = distance(modelPosition.xyz, pickerPosition);

    // Peak factor at the ring radius, falling off sharply on both sides
    float ringDist = abs(dist - ringRadius);
    float factor = clamp(1.0 - (ringDist / ringWidth), 0.0, 1.0);

    float dynamicMinSize = 2.0;
    float dynamicMaxSize = 15.0;

    gl_PointSize = mix(dynamicMinSize, dynamicMaxSize, factor);
    
    vPosition = modelPosition.xyz;
}